import SynologyImg from '../../../assets/images/itmonkeys-synology.png';
import NASImg from '../../../assets/images/itmonkeys-nas.png';
import SyncImg from '../../../assets/images/itmonkeys-sync.png'
import SecImg from '../../../assets/images/itmonkeys-sec.png'
import ContactIMG from '../../../assets/images/itmonkeys-contact.png'
import CameraIMG from '../../../assets/images/itm-camera.png'
import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import { Services } from './types';
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

export interface Service {
  id: number;
  icon: string;
  mobileIcon: string;
  alt: string;
  title: string;
  titleKey?: string;
  description: string;
  descriptionKey?: string;
  link: string;
  features: { text: string }[];
}

export const services: Services[] = [
  {
    id: 1,
    alt: 'IT Monkeys Data Leaks',
    title: 'Alertes en temps réel',
    titleKey: 'dataCyber.benefits.services.0.title',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    leftTitle: 'Centralisez vos données',
    description: "Nous mettons en place un système d'alerte en temps réel permettant à nos clients d'agir immédiatement. Nos systèmes détectent et signalent toute exposition de données sensibles appartenant à nos clients.",
    descriptionKey: 'dataCyber.benefits.services.0.description',
    link: '/#',
    features: [
      { text: 'Une fiabilité absolue et des performances constantes.' },
      { text: 'D\'importantes capacités de stockage qui peut être facilement étendues.' },
      { text: 'Protège vos données contre les défaillances de disque et les erreurs de stockage.' },
    ],
  },
  {
    id: 2,
    alt: 'Cybersecurity Icon',
    title: "Techniques d'investigation",
    titleKey: 'dataCyber.benefits.services.1.title',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    leftTitle: 'Partage en temps réel',
    description: "Nous ne nous reposons pas uniquement sur des outils génériques. Nous avons développé et sélectionné des outils de recherche avancés et des techniques d'investigation pointues pour une efficacité maximale.",
    descriptionKey: 'dataCyber.benefits.services.1.description',
    link: '/#',
    features: [
      { text: 'Simplifiez vos échanges et gagnez en efficacité.' },
      { text: 'La solution idéale pour le télétravail.' },
      { text: 'Un accès rapide et illimité à vos données, où que vous soyez.' },
    ],
  },
  {
    id: 3,
    alt: 'Cloud Service Icon',
    title: "Analyse humaine",
    titleKey: 'dataCyber.benefits.services.2.title',
    leftTitle: "Vos données sont sécurité",
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    description: "La technologie seule ne suffit pas. C'est pourquoi notre service s'appuie sur une équipe d'experts en sécurité hautement qualifiés. Ils sont spécialisés dans la recherche et l'analyse des menaces sur le Dark Web et les autres sources de renseignement.",
    descriptionKey: 'dataCyber.benefits.services.2.description',
    link: '/#',
    features: [
      { text: 'Prévenez les menaces et les pertes de données.' },
      { text: 'La tranquillité d\'esprit en sachant que vos données sont en sécurité.' },
      { text: 'Amélioration des performances et fonctionnalités.' },
      { text: 'Protection contre 99,99% des menaces.' },
    ],
  },
  {
    id: 4,
    alt: 'OpenAI Icon',
    title: 'Un accompagnement',
    titleKey: 'dataCyber.benefits.services.3.title',
    leftTitle: 'Boostez votre productivité',
    description: "Nous ne vous laissons pas seuls face aux cybermenaces. De la détection à la réponse, nous vous accompagnons et vous assurons une réponse rapide et efficace.",
    descriptionKey: 'dataCyber.benefits.services.3.description',
    link: '/#',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    features: [
      { text: 'Connectez vos équipes où qu\'elles soient.' },
      { text: 'Optimisez la gestion de vos projets.' },
      { text: 'Planifiez et organisez vos taches.' },
    ],
  },
  {
    id: 5,
    alt: 'Training Icon',
    title: 'Corrélation des fuites',
    titleKey: 'dataCyber.benefits.services.4.title',
    leftTitle: 'Soyez accompagné',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    description: "Nous comparons en permanence les nouvelles fuites avec des bases de données de leaks historiques fin de mettre en lumière les chaînes de compromission et les tendances des cyberattaques.",
    descriptionKey: 'dataCyber.benefits.services.4.description',
    link: '/#',
    features: [
      { text: 'Un contact unique qui comprend vos besoins et vos enjeux.' },
      { text: 'Réponses et solutions instantanées en cas de problèmes.' },
      { text: 'Suivi proactif des performances et mises à jour régulières.' },
    ],
  },
  {
    id: 6,
    alt: 'Training Icon',
    title: 'Analyse du mode opératoire',
    titleKey: 'dataCyber.benefits.services.5.title',
    leftTitle: 'Analyse du mode opératoire',
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    description: "Nous analysons les méthodes d'attaques et tendances des cybercriminels pour anticiper les risques avant même qu'une fuite n'affecte nos clients.",
    descriptionKey: 'dataCyber.benefits.services.5.description',
    link: '/#',
    features: [
      { text: 'Un contact unique qui comprend vos besoins et vos enjeux.' },
      { text: 'Réponses et solutions instantanées en cas de problèmes.' },
      { text: 'Suivi proactif des performances et mises à jour régulières.' },
    ],
  },
];
